import { EUROPE, SAUDI_ARABIA, USA } from "@/core/constants"
import dataRegionHelperFunction from "@/helper-functions/dataRegionHelperFunctions"
import { useStore } from "@/store"
import { ActionTypes as DataregionActions } from "@/store/modules/dataregion/actions"
import { computed } from "vue"
import { useRoute } from "vue-router"

const resellerStagingHosts = ["assessments.join-staging.com"]
export default function useOAuth() {
    let API_DOMAIN = "https://api.testlify.com"
    const route = useRoute()
    const store = useStore()
    const { getRouteRegionParam } = dataRegionHelperFunction()
    const defaultRegion = computed(() => store.getters.getDefaultRegion)
    const dataRegion = computed(() => store.getters.getSelectedDataRegion)
    let region
    if (defaultRegion.value === "") {
        if (route?.query.region) {
            region = getRouteRegionParam()
        } else if (dataRegion.value) {
            region = dataRegion.value
        } else {
            region = EUROPE
        }
    } else {
        region =
            defaultRegion.value === "EU"
                ? EUROPE
                : defaultRegion.value === "KSA"
                ? SAUDI_ARABIA
                : USA
        store.dispatch(DataregionActions.SET_SELECTED_DATA_REGION, region)
        store.dispatch(DataregionActions.SET_MANUALLY_SELECTED, false)
    }

    if (
        window.location.href.includes("app.tamayaz.sa") ||
        window.location.href.includes("albayanassessment.com") ||
        window.location.href.includes("stg.tamayaz.sa") ||
        (!(
            window.location.href.includes("localhost") ||
            window.location.href.includes("vercel")
        ) &&
            region &&
            region.includes(SAUDI_ARABIA))
    ) {
        API_DOMAIN = "https://api-ksa.testlify.com"
    }

    if (
        window.location.href.includes("usaapp.testlify.com") ||
        window.location.href.includes("qa.hnrretail.com") ||
        window.location.href.includes("assess.ahmvirtualscreen.com") ||
        (!(
            window.location.href.includes("localhost") ||
            window.location.href.includes("vercel")
        ) &&
            region &&
            region.includes(USA))
    ) {
        API_DOMAIN = "https://api-usa.testlify.com"
    }

    if (
        window.location.href.includes("localhost") ||
        window.location.href.includes("vercel") ||
        resellerStagingHosts.includes(window.location.host)
    ) {
        API_DOMAIN = "https://master.jenkins.testlify.dev"
        if (window.location.href.includes("testlify-git-staging-hnr")) {
            API_DOMAIN =
                "https://testlify-api-staging-266896172731.asia-south1.run.app"
        }
        // If you need to connect to api branch uncomment and replace the branch id in the below code
        // API_DOMAIN = `https://{branchid}.jenkins.testlify.dev`
        // API_DOMAIN = `https://testlify-api-{branchid}-266896172731.asia-south1.run.app`
    }

    const API_PREFIX = `${API_DOMAIN}/v1`
    return { API_PREFIX }
}
